<template>
  <button
    :class="[
      `${classList} ${theme} button`,
      disabled ? 'cursor-not-allowed opacity-25' : '',
      fullWidth ? 'w-full' : ' w-full sm:w-auto',
    ]"
    :data-testid="testingId"
    :disabled="disabled"
    type="button"
    @click="emitClick"
  >
    <svg
      v-if="isLeft"
      class="w-4 h-4 mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 19l-7-7 7-7"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </svg>
    {{ text }}
    <svg
      v-if="isRight"
      class="w-4 h-4 ml-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5l7 7-7 7"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </svg>
    <slot name="icon"></slot>
  </button>
</template>

<script lang="ts">
import { Direction } from '@/enums/Global';
import { computed } from '@vue/reactivity';
import { defineComponent, PropType } from 'vue';
export default defineComponent({
  name: 'Button',
  emits: ['click-action'], // without declared event
  props: {
    text: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'simple',
    },
    arrowDirection: {
      type: String as PropType<Direction>,
      default: null,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    classList: {
      type: String,
      default: '',
    },
    testingId: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const emitClick = () => {
      if (!props.disabled) {
        emit('click-action');
      }
    };

    const isRight = computed(() => props.arrowDirection === Direction.RIGHT);
    const isLeft = computed(() => props.arrowDirection === Direction.LEFT);

    return { emitClick, isRight, isLeft };
  },
});
</script>

<style lang="postcss" scoped>
.button {
  @apply inline-flex mb-3 sm:mb-0 justify-center text-center items-center rounded-md px-4 py-2 transition duration-500 select-none focus:ring;
}

.minimal {
  @apply border-0 bg-white text-primary hover:text-primary-tint;
}
.simple {
  @apply border border-primary bg-white text-primary hover:border-primary-tint hover:text-primary-tint;
}
.simple-small {
  @apply border border-primary bg-white text-primary hover:border-primary-tint hover:text-primary-tint px-2 py-1;
}
.full {
  @apply border border-primary bg-primary hover:border-primary-tint hover:bg-primary-tint text-white;
}
</style>
